import React, { useEffect, useState } from 'react';
import { FaTimes, FaNetworkWired, FaCheckCircle, FaFilePdf } from 'react-icons/fa';
import PdfViewer from './PdfViewer';
import NoPdfMessage from './NoPdfMessage';
import './DeviceModal.css';

const DeviceModal = ({ device, onClose }) => {
  const [showPdf, setShowPdf] = useState(false);
  const [showNoPdfMessage, setShowNoPdfMessage] = useState(false);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  const handleBackdropClick = (e) => {
    if (e.target.className === 'modal-backdrop') {
      onClose();
    }
  };

  const handleViewPdf = () => {
    if (device.pdfManual) {
      setShowPdf(true);
    } else {
      setShowNoPdfMessage(true);
    }
  };

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="modal-content">
        <button className="modal-close" onClick={onClose}>
          <FaTimes />
        </button>

        <div className="modal-header">
          <div className="modal-header-content">
            <h2 className="modal-title">{device.name}</h2>
            <div className="modal-meta">
              <span className="modal-badge">{device.category}</span>
              <div className="modal-port">
                <FaNetworkWired />
                <span>Protocolo: {device.protocol} | Porta: {device.port}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="modal-body">
          <div className="device-features-section">
            <h3>Recursos Principais</h3>
            <div className="features-grid">
              {device.features.map((feature, index) => (
                <div key={index} className="feature-tag">
                  <FaCheckCircle />
                  {feature}
                </div>
              ))}
            </div>
          </div>

          <div className="documentation-section">
            <div className="markdown-content">
              {device.documentation.split('\n').map((line, index) => {
                if (line.startsWith('# ')) {
                  return <h1 key={index}>{line.substring(2)}</h1>;
                } else if (line.startsWith('## ')) {
                  return <h2 key={index}>{line.substring(3)}</h2>;
                } else if (line.startsWith('### ')) {
                  return <h3 key={index}>{line.substring(4)}</h3>;
                } else if (line.startsWith('- ')) {
                  return <li key={index}>{line.substring(2)}</li>;
                } else if (line.trim() === '') {
                  return <br key={index} />;
                } else {
                  return <p key={index}>{line}</p>;
                }
              })}
            </div>
          </div>

          <div className="modal-footer">
            <button onClick={handleViewPdf} className="btn-pdf-modal">
              <FaFilePdf /> Ver Manual PDF
            </button>
            <button onClick={onClose} className="btn-secondary-modal">
              Fechar
            </button>
            <button 
              onClick={() => {
                const contactSection = document.getElementById('contact');
                if (contactSection) {
                  onClose();
                  setTimeout(() => {
                    contactSection.scrollIntoView({ behavior: 'smooth' });
                  }, 300);
                }
              }}
              className="btn-primary-modal"
            >
              Solicitar Orçamento
            </button>
          </div>
        </div>
      </div>

      {/* PDF Viewer */}
      {showPdf && (
        <PdfViewer 
          pdfPath={device.pdfManual}
          deviceName={device.name}
          onClose={() => setShowPdf(false)}
        />
      )}

      {/* Mensagem sem PDF */}
      {showNoPdfMessage && (
        <NoPdfMessage 
          deviceName={device.name}
          onClose={() => setShowNoPdfMessage(false)}
        />
      )}
    </div>
  );
};

export default DeviceModal;

